package com.trevorwiebe.timesheet.admin.organization.presentation

import com.trevorwiebe.timesheet.core.domain.Util
import kotlinx.datetime.LocalDate

data class OrganizationState(
    val name: String = "",
    val goLiveDate: LocalDate = Util.localDateTime(atTopOfDay = true).date,
    val billingAddress: String = "",
    val billingPhone: String = "",
    val billingEmail: String = "",
    val remitTo: String = "",
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val isSaved: Boolean = false,
    val error: String? = null,
)
